import * as React from 'react';
import Modal, { closeStyle } from 'simple-react-modal';

class InfoIcon extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            QuestionsAndAnswers: []
        }
    }

    componentWillMount() {
        this.fetchAnswersForCompare(this.props.id, this.props.stateCode, this.props.questionId);
    }
    show() {
        this.setState({ show: true })
    }

    close() {
        this.setState({ show: false })
    }
    render() {
        return (
            <div>
                <a className="moreInfo-icon" onClick={this.show.bind(this)}><i className="fa fa-info-circle fa-lg" aria-hidden="true" title="Click for additional information"></i></a>
                    <Modal closeOnOuterClick={true} show={this.state.show} onClose={this.close.bind(this)} >
                        <a style={closeStyle} onClick={this.close.bind(this)}>X</a>
                        <div className="modal-title">Additional Information</div>
                        
                        {this.state.QuestionsAndAnswers.filter(qa => this.props.sectionName != 'Fees').map((info, key) => 
                        <div> 
                            <div>Requirement: {info.QuestionText} </div>
                            {info.AnswerTextList.map((AnswerText, index) =>
                                index == 0 ? (
                                    <div>Answer: {AnswerText}</div>
                                ) : (
                                    <div>{AnswerText}</div>
                                )
                            )}
                            <br/>
                        </div>
                        )}

                        {this.state.QuestionsAndAnswers.filter(qa => this.props.sectionName == 'Fees').map((info, key) => 
                        <div> 
                            <div>Fee: {info.QuestionText}</div>
                            <div>Amount: {info.AnswerText}</div>
                            <br/>
                        </div>
                        )}
                        

                    </Modal>                
            </div>
        );
    }

    fetchAnswersForCompare(id, stateCode, questionId) {
        fetch(`${process.env.REACT_APP_API_URL}/api/licensing/${id}/jurisdictionAnswers/${stateCode}/question/${questionId}`)
        .then(function (response) {
            return response.json();
        })
        .then((data) => {
            // console.log(data);
            this.setState({
                QuestionsAndAnswers: data.QuestionsAndAnswers
            })
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/components/InfoIcon.js